var Sizes;
(function (Sizes) {
  Sizes["SMALL"] = "small";
  Sizes["MEDIUM"] = "medium";
  Sizes["LARGE"] = "large";
})(Sizes || (Sizes = {}));
const ImageSizes = {
  [Sizes.SMALL]: 200,
  [Sizes.MEDIUM]: 300,
  [Sizes.LARGE]: 500
};

export { ImageSizes as I, Sizes as S };
//# sourceMappingURL=common-DBpCdW70.esm.js.map
